import { queryOptions } from "@tanstack/react-query";
import { $getProjectOverview } from "./functions";

export const projectOverviewQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["projects", projectId, "overview"],
    queryFn: ({ signal }) => $getProjectOverview({ signal, data: { projectId } }),
    staleTime: 0, // Always refetch for up-to-date stats
  });
